const normalizeText = (value) => {
  const normalized = String(value || '').trim();
  return normalized || null;
};

const isObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const extractDeliveryEstimate = (source) => {
  if (!isObject(source)) {
    return null;
  }

  const nested = isObject(source.delivery_estimate)
    ? source.delivery_estimate
    : (isObject(source.deliveryEstimate) ? source.deliveryEstimate : null);
  const snapshot = isObject(source.delivery_estimate_snapshot) ? source.delivery_estimate_snapshot : null;
  const ruleSnapshot = isObject(snapshot?.rule_snapshot) ? snapshot.rule_snapshot : null;

  const label = normalizeText(
    nested?.label
      || snapshot?.label
      || source.delivery_estimate_label,
  );
  const estimatedDeliveryDate = normalizeText(
    nested?.estimated_delivery_date
      || snapshot?.estimated_delivery_date
      || source.estimated_delivery_date,
  );

  if (!label && !estimatedDeliveryDate) {
    return null;
  }

  return {
    label,
    estimatedDeliveryDate,
    businessDaysOnly: Boolean(
      nested?.business_days_only
        ?? snapshot?.business_days_only
        ?? source.estimated_delivery_business_days_only
    ),
    resolved: Boolean(nested?.resolved ?? snapshot?.resolved ?? label),
    minHours: nested?.min_hours ?? snapshot?.min_hours ?? source.delivery_estimate_min_hours ?? null,
    maxHours: nested?.max_hours ?? snapshot?.max_hours ?? source.delivery_estimate_max_hours ?? null,
    priority: nested?.priority ?? snapshot?.priority ?? ruleSnapshot?.priority ?? null,
    raw: nested || snapshot || source,
  };
};

export const formatDeliveryEstimateDate = (value) => {
  const candidate = normalizeText(value);
  if (!candidate) {
    return null;
  }

  const date = new Date(candidate);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const options = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  };

  if (date.getFullYear() !== new Date().getFullYear()) {
    options.year = 'numeric';
  }

  return date.toLocaleDateString('fr-FR', options);
};
